import { select } from "@ngneat/elf";
import { selectAllEntities } from "@ngneat/elf-entities";
import { transactionStore, transactionPeriodStore } from "./transaction.store";
import { GETTransactionByIdDataSource, GETTransactionTotalDataSource } from "./transaction.requests";

export class TransactionQuery {
  store = transactionStore;

  transactions$ = this.store.pipe(selectAllEntities());
  filters$ = this.store.pipe(select((state) => state.filters));
  loading$ = this.store.pipe(select((state) => state.loading));
  hasMore$ = this.store.pipe(select((state) => state.hasMore));
  totals$ = GETTransactionTotalDataSource.data$();
  transaction$ = this.store.pipe(select((state) => ({ transaction: state.transaction })));
  exportTransaction$ = this.store.pipe(select((state) => ({ exportTransaction: state.exportTransaction })));

  companyExportTransactionConfig$ = this.store.pipe(select((state) => state.exportTransaction));

  trasaction$ = GETTransactionByIdDataSource.data$();

  periods$ = transactionPeriodStore.pipe(selectAllEntities());
  selectedPeriod$ = transactionStore.pipe(select((state) => state.selectedPeriod));
}

export const transactionsQuery = new TransactionQuery();
